"use client";

import { useState } from "react";
import { fileReport } from "@/lib/report-actions";
import SubmitButton from "./SubmitButton";

const REASONS = [
  "Inaccurate listing",
  "Suspected scam or fraud",
  "Inappropriate photos",
  "Discriminatory content",
  "Safety concern",
  "Other",
];

export default function ReportButton({
  targetType,
  targetId,
}: {
  targetType: "Listing" | "User" | "Review";
  targetId: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-xs text-neutral-500 hover:text-rose-600 hover:underline"
      >
        Report
      </button>
      {open ? (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-white rounded-xl max-w-md w-full p-5" onClick={(e) => e.stopPropagation()}>
            <h2 className="font-semibold">Report this {targetType.toLowerCase()}</h2>
            <p className="text-xs text-neutral-500 mt-1">
              Our trust &amp; safety team will review within 48 hours.
            </p>
            <form action={fileReport} className="mt-4 space-y-3">
              <input type="hidden" name="targetType" value={targetType} />
              <input type="hidden" name="targetId" value={targetId} />
              <label className="block">
                <span className="text-xs font-semibold uppercase tracking-wide text-neutral-600">Reason</span>
                <select name="reason" required className="input mt-1">
                  {REASONS.map((r) => <option key={r} value={r}>{r}</option>)}
                </select>
              </label>
              <label className="block">
                <span className="text-xs font-semibold uppercase tracking-wide text-neutral-600">Details (optional)</span>
                <textarea name="details" rows={4} maxLength={2000} className="input mt-1" />
              </label>
              <div className="flex justify-end gap-2">
                <button type="button" onClick={() => setOpen(false)} className="text-sm px-3 py-2 hover:bg-neutral-50 rounded-lg">
                  Cancel
                </button>
                <SubmitButton pendingLabel="Submitting…">Submit report</SubmitButton>
              </div>
            </form>
            <style>{`.input{width:100%;border:1px solid #e5e5e5;border-radius:0.5rem;padding:0.5rem 0.75rem;font-size:0.875rem;outline:none;background:white}.input:focus{border-color:#e11d48}`}</style>
          </div>
        </div>
      ) : null}
    </>
  );
}
